import moment, { MomentInput } from 'moment';

export function isPlannedPeriodWithinThreshold(
  employmentDateFrom: MomentInput | null | undefined,
  employmentDateTo: MomentInput | null | undefined,
  plannedPeriodThresholdMonths: number | null | undefined,
): boolean {
  if (!plannedPeriodThresholdMonths || plannedPeriodThresholdMonths <= 0) {
    return false;
  }

  const fromDate = toDateOnly(employmentDateFrom);
  const toDate = toDateOnly(employmentDateTo);

  if (!fromDate || !toDate) {
    return false;
  }

  if (toDate.isBefore(fromDate, 'day')) {
    return false;
  }

  const maxDateForShortTrial = fromDate.clone().add(plannedPeriodThresholdMonths, 'months').subtract(1, 'day');

  return toDate.isBefore(maxDateForShortTrial, 'day');
}

function toDateOnly(date: MomentInput | null | undefined) {
  if (!date) {
    return null;
  }

  const normalizedDate = moment(date);
  return normalizedDate.isValid() ? normalizedDate.startOf('day') : null;
}
